document.addEventListener("DOMContentLoaded", function () {
    let mobileSwiper = null;
  
    function initMobileSwiper() {
      if (window.innerWidth < 990 && !mobileSwiper) {
        mobileSwiper = new Swiper('#rubbit-in-action-slider', {
          slidesPerView: 3.7,
          spaceBetween: 10,
          slidesOffsetBefore: 13,
          slidesOffsetAfter: 13,
          loop: true,
        });
      }
  
      if (window.innerWidth >= 990 && mobileSwiper) {
        mobileSwiper.destroy(true, true);
        mobileSwiper = null;
      }
    }
  
    initMobileSwiper();
    window.addEventListener("resize", initMobileSwiper);
  
  
    // ----------------------------
    // VIDEO PLAY / PAUSE HANDLING
    // ----------------------------
  
    const slides = document.querySelectorAll(".rubbit-video-slide");
    slides.forEach((slide) => {
      const video = slide.querySelector("video");
      const playBtn = slide.querySelector(".play_button");
  
      if (!video || !playBtn) return;
  
      // Play video on play-button click
      playBtn.addEventListener("click", function () {
        // Pause all other videos
        document.querySelectorAll(".rubbit-video-slide video").forEach((v) => {
          if (v !== video) {
            v.pause();
            v.currentTime = 0;
            v.closest(".rubbit-video-slide")
              .querySelector(".play_button")
              .style.display = "flex";
          }
        });
  
        playBtn.style.display = "none";
        video.play();
      });
  
      // Pause on clicking the video
      video.addEventListener("click", function () {
        if (!video.paused) {
          video.pause();
          playBtn.style.display = "flex";
        }
      });
  
      // When video ends, show button again
      video.addEventListener("ended", function () {
        playBtn.style.display = "flex";
        video.currentTime = 0;
      });
    });

    // ----------------------------
    // BUY NOW BUTTON HANDLING (BFCM Specific)
    // ----------------------------
    
    // Separate Buy Now handler for BFCM module
    function handleBFCMBuyNow(button) {
      const variantId = document.querySelector('#product-form input[name="id"]')?.value;
      const sellingPlanId = button.getAttribute('data-selling-plan-id');
      
      if (!variantId) {
        console.error('Variant ID not found');
        return;
      }
      
      // Store original text
      if (!button.dataset.originalText) {
        button.dataset.originalText = button.textContent.trim();
      }
      const originalText = button.dataset.originalText;
      
      // Set loading state
      button.disabled = true;
      button.style.opacity = '0.6';
      button.style.cursor = 'not-allowed';
      button.textContent = 'Processing...';
      
      // Create item object
      const item = {
        id: variantId,
        quantity: 1
      };
      
      // Add selling plan if subscription is enabled
      if (sellingPlanId) {
        item.selling_plan = sellingPlanId;
      }
      
      const items = [item];
      
      // Add to cart and redirect to checkout
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ items: items })
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to add to cart');
        }
        return response.json();
      })
      .then(data => {
        // Show success state briefly before redirect
        button.textContent = 'Redirecting...';
        setTimeout(() => {
          window.location.href = '/checkout';
        }, 500);
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
        
        // Show error state
        button.textContent = 'Error - Try Again';
        button.style.opacity = '1';
        
        // Reset button state after 3 seconds
        setTimeout(() => {
          button.disabled = false;
          button.style.opacity = '1';
          button.style.cursor = 'pointer';
          button.textContent = originalText;
        }, 3000);
      });
    }
    
    // Separate Add to Cart handler for BFCM module
    function handleBFCMAddToCart(button, event) {
      event.preventDefault();
      
      const variantId = document.querySelector('#product-form input[name="id"]')?.value;
      const sellingPlanId = button.getAttribute('data-selling-plan-id');
      
      if (!variantId) {
        console.error('Variant ID not found');
        return;
      }
      
      // Store original text
      if (!button.dataset.originalText) {
        button.dataset.originalText = button.textContent.trim();
      }
      const originalText = button.dataset.originalText;
      
      // Set loading state
      button.disabled = true;
      button.style.opacity = '0.6';
      button.style.cursor = 'not-allowed';
      button.textContent = 'Adding...';
      
      // Create item object
      const item = {
        id: variantId,
        quantity: 1
      };
      
      // Add selling plan if subscription is enabled
      if (sellingPlanId) {
        item.selling_plan = sellingPlanId;
      }
      
      const items = [item];
      
      // Add to cart
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ items: items })
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to add to cart');
        }
        return response.json();
      })
      .then(data => {
        // Fetch updated cart
        return fetch('/cart.js');
      })
      .then(response => response.json())
      .then(cartData => {
        // Update cart UI if updateCart function exists
        if (window.updateCart) {
          window.updateCart(cartData);
        }
        
        // Show success state
        button.textContent = 'Added!';
        button.style.opacity = '1';
        
        // Open cart drawer if available
        if (window.openCartDrawer) {
          window.openCartDrawer();
        }
        
        // Reset button state after 2 seconds
        setTimeout(() => {
          button.disabled = false;
          button.style.opacity = '1';
          button.style.cursor = 'pointer';
          button.textContent = originalText;
        }, 2000);
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
        
        // Show error state
        button.textContent = 'Error - Try Again';
        button.style.opacity = '1';
        
        // Reset button state after 3 seconds
        setTimeout(() => {
          button.disabled = false;
          button.style.opacity = '1';
          button.style.cursor = 'pointer';
          button.textContent = originalText;
        }, 3000);
      });
    }
    
    // Initialize BFCM Buy Now buttons
    const bfcmBuyNowButtons = document.querySelectorAll('[data-bfcm-buy-now]');
    bfcmBuyNowButtons.forEach(button => {
      if (button.dataset.bfcmBuyNowInitialized === 'true') {
        return;
      }
      button.dataset.bfcmBuyNowInitialized = 'true';
      button.addEventListener('click', function(e) {
        e.preventDefault();
        if (button.disabled || button.classList.contains('disabled')) {
          return;
        }
        handleBFCMBuyNow(button);
      });
    });
    
    // Initialize BFCM Add to Cart buttons
    const bfcmAddToCartButtons = document.querySelectorAll('[data-bfcm-add-to-cart]');
    bfcmAddToCartButtons.forEach(button => {
      if (button.dataset.bfcmAddToCartInitialized === 'true') {
        return;
      }
      button.dataset.bfcmAddToCartInitialized = 'true';
      button.addEventListener('click', function(e) {
        if (button.disabled || button.classList.contains('disabled')) {
          e.preventDefault();
          return;
        }
        handleBFCMAddToCart(button, e);
      });
    });
  });

